import { render, staticRenderFns } from "./folderTreeDialog.vue?vue&type=template&id=5246de8e&"
import script from "./folderTreeDialog.vue?vue&type=script&lang=js&"
export * from "./folderTreeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports